<template>
  <div class="five_step py-15 px-20">
    <div class="five_step_text flex Flexalign FlexBetween">
      <div>五步学习流程</div>
      <div class="learning_guide cursor_pointer" @click="openLearningGuide">操作指引 ></div>
    </div>
    <div class="flex Flexalign FlexBetween mt-10" :key="refreshey">
      <div class="flex-1" v-for="(item, index) in infoList.filter((item) => item.show)" :key="index"
        @mouseenter="showHightColor(item.value)" @mouseleave="hideHightColor('')">
        <div class="percent_collage_box" :style="getLeftPosition(item.progress)"
          :class="item.status != 3 ? 'percent_collage_box_none' : ''">
          <el-image class="percent_collage" :src="iconPath('percent_collage.png')"></el-image>
          <div class="percent_collage_percent">{{ item.progress }}%</div>
        </div>
        <div class="progress-container" :class="[
          index == 0 || index == infoList.length - 1
            ? 'progress-container-both'
            : '',
        ]" @click="changeMenu(item)">
          <div class="progress-track" :class="[
            index != 0 || index != infoList.length - 1
              ? 'progress-wrapper'
              : '',
          ]">
            <el-icon class="isFinish_icon" v-if="item.progress == 100">
              <Check />
            </el-icon>
            <div class="progress-bg" :class="[
              index == 0 ? 'type1' : '',
              index == infoList.length - 1 ? 'type2' : '',
            ]"></div>
            <!-- type1 type2 -->
            <div class="progress-fill" :class="[
              index == 0 ? 'type1' : '',
              index == infoList.length - 1 ? 'type2' : '',
              item.progress == 100 ? 'progress-fill-full' : '',
            ]" :style="{ width: item.progress + '%' }"></div>
          </div>
        </div>
        <div class="step_collage_box cursor_pointer" :style="getLeftPosition(item.progress)" @click="changeMenu(item)">
          <el-image class="one_active" :src="getImg(item.icon, item.status, item.value)"></el-image>
          <div class="step_label" :class="item.status == 2
            ? 'step_label_default'
            : item.status == 3
              ? 'step_label_active'
              : 'step_label'
            ">
            <div :class="[(hightValue == item.value) ? 'text_active' : '']">{{ `第${getStepNum(item.value)}步
              ${item.label}` }}
            </div>
            <div class="step_active_lise" v-if="item.status == 3"></div>
          </div>
          <div class="step_desc" :class="item.status == 2
            ? 'step_desc_default'
            : item.status == 3
              ? 'step_desc_active'
              : 'step_desc'
            ">
            {{ item.desc }}
          </div>
        </div>
      </div>
    </div>

    <learningGuide ref="learningGuide"></learningGuide>
  </div>
</template>

<script>
import learningGuide from "@/components/popup/learningGuide.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5FiveStep",
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      studySteps: (state) => state.learning.studySteps,
      studyStepInfo: (state) => state.learning.studyStepInfo,
      studyPreviousStep: (state) => state.learning.studyPreviousStep,
      isHomeworkBack: (state) => state.learning.isHomeworkBack,
      isChallengeBack: (state) => state.learning.isChallengeBack,
      isFreeLearning: (state) => state.learning.isFreeLearning,
    }),
  },
  components: {
    learningGuide
  },
  props: {
    step: {},
    wrongProgres: {},
    courseSettingInfo: {}
  },
  inject: ["changeSchoolMenu"],
  watch: {
    studySteps() {
      // 查找视频后的第一个开启五步
      let num = 1;
      for (let i = 1; i < this.infoList.length; i++) {
        if (this.infoList[i].show) {
          num = this.infoList[i].value;
          break;
        }
      }
      // 如果num为1表示当前阶段只配置了输入这一步，此时输入完成后需要触发章节阶段切换，否则执行五步的下一步
      if (num == 1) {
        this.$store.commit("learning/setStudyChapter");
      } else {
        this.changeMenu({ value: num });
        // this.getChapterProgress();
      }
    },
    // 用于处理下一步逻辑
    studyStepInfo: {
      handler() {
        // 查找当前五步后的第一个开启五步
        let num = this.studyStepInfo.step;
        for (let i = num; i < this.infoList.length; i++) {
          if (this.infoList[i].show) {
            num = this.infoList[i].value;
            break;
          }
        }
        // 查找最后一个开启的五步(判断是否等于当前步骤，等于说明是最后一步，执行章节阶段切换逻辑)
        let lastOpenValue = this.infoList.findLast(item => item.show)?.value;
        // 如果num为1表示当前阶段只配置了输入这一步，此时输入完成后需要触发章节阶段切换，否则执行五步的下一步，或者当前完成的五步是最后一个五步
        if (num == 1 || (lastOpenValue == (this.step + 1))) {
          // 此处加上判断，如果是试学，则不跳转（避免当前阶段是开放，下一阶段不开放，导致跳转至下一阶段）
          if (this.isFreeLearning) {
            return
          }
          this.$store.commit("learning/setStudyChapter");
        } else {
          this.changeMenu({ value: num });
          // this.getChapterProgress();
        }
      },
      deep: true,
    },
    // 用于处理上一步逻辑
    studyPreviousStep: {
      handler() {
        // 查找当前五步后的往前一个开启的五步
        let num = this.studyPreviousStep.step;
        let previousNum = 1;
        for (let i = 0; i < num - 1; i++) {
          if (this.infoList[i].show) {
            previousNum = this.infoList[i].value;
          }
        }
        // 查找第一个开启的五步(判断是否等于当前步骤，等于说明是最后一步，执行章节阶段切换逻辑)
        let firstOpenValue = this.infoList.findIndex(item => item.show);
        // 如果num为1表示当前阶段只配置了输入这一步，此时上一步需要触发章节阶段切换，或者当前完成的五步是当前开启的第一个五步，则也触发章节阶段切换，否则五步执行上一步
        if (firstOpenValue == this.step) {
          this.$store.commit("learning/setStudyPreviousChapter");
        } else {
          this.changeMenu({ value: previousNum });
        }
      },
      deep: true,
    },
    selectLearningInfo: {
      handler() {
        if (this.isHomeworkBack) {
          this.changeMenu({ value: 2 });
          setTimeout(() => {
            this.$store.commit("learning/setIsHomeworkBack", false);
          }, 500);
        } else if (this.isChallengeBack) {
          this.changeMenu({ value: 3 });
          setTimeout(() => {
            this.$store.commit("learning/setIsChallengeBack", false);
          }, 500);
        } else {
          this.changeMenu({ value: 1 });
        }
        this.getChapterProgress();
        /** step监听，如果是视屏需要新增定时器实时查看观看进度，并判断是否已完成，未完成则始终低于100，但需要计算实际百分比，完成展示100, */
      },
      deep: true,
    },
  },

  data() {
    return {
      infoList: [
        {
          label: "课程学习",
          icon: "one_active",
          state: "学习中",
          progress: 0,
          value: 1,
          show: true,
          desc: "视频学知转化",
          status: 3, // 1、未解锁，2、解锁默认，3、选中
          field: "inputEnabled",
          fieldStatu: "inputStatus",
        },
        {
          label: "知识点通关",
          icon: "two_active",
          state: "学习中",
          progress: 0,
          value: 2,
          show: true,
          desc: "知识关卡逐个通关",
          status: 1,
          field: "outputEnabled",
          fieldStatu: "outputStatus",
        },
        {
          label: "课时闯关",
          icon: "three_active",
          state: "学习中",
          progress: 0,
          value: 3,
          show: true,
          desc: "测试闯关逐关突破",
          status: 2,
          field: "passEnabled",
          fieldStatu: "passStatus",
        },
        {
          label: "消灭错题",
          icon: "four_active",
          state: "学习中",
          progress: 0,
          value: 4,
          show: true,
          desc: "错题剖析精准诊断",
          status: 1,
          field: "wrongEnabled",
          fieldStatu: "wrongStatus",
        },
        {
          label: "测评通关",
          icon: "five_active",
          state: "学习中",
          progress: 0,
          value: 5,
          show: true,
          desc: "阶段考核步步赢",
          status: 1,
          field: "finalEnabled",
          fieldStatu: "finalStatus",
        },
      ],
      selectInfoValue: 1,
      timeIntervalProgress: null,
      hightValue: '',
      refreshey: 0,
    };
  },

  mounted() {
    // this.infoList[this.step].status = 3;
    this.getChapterProgress();
  },
  unmounted() {
    if (this.timeIntervalProgress) {
      clearInterval(this.timeIntervalProgress);
      this.timeIntervalProgress = "";
    }
  },

  methods: {
    // 指引流程
    openLearningGuide() {
      this.$refs.learningGuide.currentIndex = 0;
      this.$refs.learningGuide.learningGuideShow = true;
    },
    showHightColor(value) {
      this.hightValue = value;
    },
    hideHightColor() {
      this.hightValue = '';
    },
    getLeftPosition(progress) {
      return `left:calc(${progress}% - 21px);`;
    },
    getImg(url, status, num) {
      let stepNum = this.getStepNum(num);
      let icon = "";
      if (stepNum == 1) {
        icon = "one_active";
      } else if (stepNum == 2) {
        icon = "two_active";
      } else if (stepNum == 3) {
        icon = "three_active";
      } else if (stepNum == 4) {
        icon = "four_active";
      } else if (stepNum == 5) {
        icon = "five_active";
      }
      return this.iconPath(icon + status + ".png");
    },
    getStepNum(num) {
      let count = 0;
      for (let i = 0; i < num - 1; i++) {
        if (this.infoList[i].show == false) {
          count++;
        }
      }
      return num - count;
    },
    startInterval() {
      this.timeIntervalProgress = setInterval(() => {
        this.$Api.course
          .getMyCourseChapterProgress({
            schemeChapterPhaseId: this.selectLearningInfo?.id,
          })
          .then((res) => {
            if (res.data.data.watchedProgress) {
              if (res.data.data.inputStatus == 1) {
                this.infoList[0].progress = 100;
              } else {
                this.infoList[0].progress = res.data.data.watchedProgress;
              }
            }
          });
      }, 60000);
    },
    // 获取当前章节学习进度
    getChapterProgress(value) {
      if (this.$Tools.empty(this.selectLearningInfo)) return;
      // 判断是否是第一步，第一步设置定时器定时查询当前播放进度
      if (this.step == 0) {
        if (this.timeIntervalProgress) {
          clearInterval(this.timeIntervalProgress);
          this.timeIntervalProgress = null;
        }
        this.startInterval();
      }
      // 加个判断，输出这一步是否展示(控制五步是否展示)
      this.infoList.forEach((item) => {
        if (this.selectLearningInfo[item.field] == 0) {
          item.show = false;
          item.status = 1;
        } else if (this.selectLearningInfo[item.field] == 1) {
          item.show = true;
          item.status = 2;
        }
      });
      this.$Api.course
        .getMyCourseChapterProgress({
          schemeChapterPhaseId: this.selectLearningInfo?.id,
        })
        .then((res) => {
          this.chapterPorgress = res.data.data;
          if (this.chapterPorgress.inputStatus == 1) {
            this.infoList[0].progress = 100;
          } else {
            this.infoList[0].progress = 0;
            if (res.data.data.watchedProgress) {
              this.infoList[0].progress = res.data.data.watchedProgress;
            }
          }
          if (this.chapterPorgress.outputStatus == 1) {
            this.infoList[1].progress = 100;
          } else {
            this.infoList[1].progress = 0;
          }
          if (this.chapterPorgress.passStatus == 1) {
            this.infoList[2].progress = 100;
          } else {
            this.infoList[2].progress = 0;
          }
          if (this.chapterPorgress.wrongStatus == 1) {
            this.infoList[3].progress = 100;
          } else {
            setTimeout(() => {
              this.infoList[3].progress = this.wrongProgres || 0;
            }, 1500)
          }
          if(this.chapterPorgress.finalStatus == 1){
            this.infoList[4].progress = 100;
          }else {
            this.infoList[4].progress = 0;
          }
          // 临时取消限制（当前接口中状态未能同步）视频可能未配置，此时不限制
          for (let i = 1; i < value; i++) {
            let fieldInfo = this.infoList.filter((item) => item.value == i)[0];
            // 允许跳过直接下一步(是否允许跳过)
            if (this.courseSettingInfo?.learningAllowSkipInput == 1 && this.infoList[0].show && this.infoList[0].progress != 100) {
              // 此时要查询当前value前一个是不是视频，若不是视频不允许跳过，提示按顺序完成，是视频则可以跳过
              let valueIndex = this.infoList.findIndex(item => item.value == value);
              if (valueIndex != 0 || valueIndex != -1) {
                let lastShowValue = '';
                // 找离valueIndex最近的一个show为true的value值，如果是1则说明上一步是视频学习
                for (let i = 0; i < valueIndex; i++) {
                  if (this.infoList[i].show) {
                    lastShowValue = this.infoList[i].value;
                  }
                }
                if (lastShowValue != 1) {
                  // 恢复上一步的高亮状态
                  fieldInfo.status = 3;
                  this.changeSchoolMenu(fieldInfo.value);
                  this.$Dialog.toast("请先完成前面步骤", { type: "warning" });
                  return
                } else {
                  // 此处新增强制完成视频学习的逻辑接口
                  this.confirmPassInputStatus();
                }
              } else {
                return
              }
            } else {
              if (this.selectLearningInfo[fieldInfo.field] == 1) {
                if (this.chapterPorgress[fieldInfo.fieldStatu] != 1) {
                  // 恢复上一步的高亮状态
                  fieldInfo.status = 3;
                  this.$Dialog.toast(`请先完成${fieldInfo.label}`, {
                    type: "warning",
                  });
                  this.changeSchoolMenu(fieldInfo.value);
                  return;
                }
              }
            }
            // if (value == 5) break;

          }
          // if ((value == 2 && this.selectLearningInfo.inputEnabled == 1) || (value == 3 && this.selectLearningInfo.inputEnabled == 1)) {
          //   if (this.chapterPorgress.inputStatus != 1) {
          //     this.$Dialog.toast("请先完成课程学习", { type: "warning" });
          //     return;
          //   }
          // }
          // // 输出可能未配置，此时不限制
          // if (value == 3 && this.selectLearningInfo.outputEnabled == 1) {
          //   if (this.chapterPorgress.outputStatus != 1) {
          //     this.$Dialog.toast("请先完成知识点通关", { type: "warning" });
          //     return;
          //   }
          // }
          if (value) {
            this.selectInfoValue = value;
            this.changeSchoolMenu(value);
          }
          // 展示第一个后台配置的五步(用于判断当前步骤是否可展示，不可展示则默认展示第一个show为true的步骤)
          if (this.infoList[this.step]?.show == false) {
            let showIndex = this.infoList.findIndex((item) => item.show);
            if (showIndex != -1) {
              this.changeSchoolMenu(this.infoList[showIndex]?.value);
            }
          }
          let findIndex = this.infoList.findIndex(
            (item) => item.value - 1 == this.step
          );
          if (findIndex != -1) {
            this.infoList[findIndex].status = 3;
          }
        });
    },
    confirmPassInputStatus() {
      if (!this.selectLearningInfo.chapterResource?.schemeChapterPhaseId) return;
      this.$Api.learning
        .confirmPassInputStatus({
          schemeChapterPhaseId: this.selectLearningInfo.chapterResource
            ?.schemeChapterPhaseId,
        })
        .then(() => {
          // this.infoList[0].progress = 100;
          this.$Api.course
            .getMyCourseChapterProgress({
              schemeChapterPhaseId: this.selectLearningInfo?.id,
            })
            .then(() => {
              // 直接更新本地状态，不等待接口返回
              this.infoList[0].progress = 100;
              this.chapterPorgress.inputStatus = 1;
              this.refreshey++;
            })
        })
        .catch(() => { });
    },
    changeMenu(info) {
      // 新增主动触发学习进度结算更新（仅视频观看完成后调用该接口，此处添加防止后端切片统计不及时的问题，再次触发再去判断inputStatus状态是否为1）,视频资源存在的情况
      if (!this.$Tools.empty(this.selectLearningInfo?.chapterResource)) {
        this.$Api.course
          .settlementVideoSegment({
            resourceId: this.selectLearningInfo?.chapterResource.resourceId,
            startSeconds: 0,
            endSeconds: 0,
          })
          .then(() => { });
      }
      // 获取最新的进度（除纠错阶段）
      // if (info.value != 4 || info.value != 1 || info.value != 5) {
      if (info.value != 1) {
        this.getChapterProgress(info.value);
        // this.selectInfoValue = info.value;
        // this.changeSchoolMenu(info.value);
      } else {
        this.selectInfoValue = info.value;
        this.changeSchoolMenu(info.value);
        let findIndex = this.infoList.findIndex(
          (item) => item.value == this.step
        );
        if (findIndex != -1) {
          this.infoList[findIndex].status = 3;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.five_step {
  height: 190px;
  background: #ffffff;
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  box-sizing: border-box;

  .five_step_text {
    color: #111111;
    font-weight: 600;
    font-size: 18px;

    .learning_guide {
      font-size: 14px;
      color: #999;
      font-weight: normal;
    }
  }

  .progress-container {
    flex: 1;
    min-width: 134px;
    // height: 28px;
    // background: #f8f9fa;
    border-radius: 12px;
    // padding: 25px;
    // box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .progress-wrapper {
    position: relative;
    height: 28px;
    margin: 5px 0;

    .isFinish_icon {
      position: absolute;
      text-align: center;
      width: 14px;
      height: 10px;
      top: 9px;
      left: calc(50% - 7px);
      z-index: 9;
      color: #ffffff;
    }

    .progress-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #e0e0e0;
      /* 特殊形状裁剪 */
      clip-path: polygon(0 0,
          calc(100% - 14px) 0,
          100% 50%,
          calc(100% - 14px) 100%,
          0 100%,
          14px 50%);
      border-radius: 5px;
    }

    .progress-fill {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      /* 相同的特殊形状裁剪 */
      clip-path: polygon(0 0,
          calc(100% - 14px) 0,
          100% 50%,
          calc(100% - 14px) 100%,
          0 100%,
          14px 50%);
      //   clip-path: polygon(
      //     0 0,
      //     calc(100% - 14px) 0,
      //     100% 0%,
      //     100%,
      //     0 100%,
      //     14px 50%
      //   );
      border-radius: 5px;
      transition: width 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
    }
  }

  .progress-container-both {
    margin: 5px 0;
    position: relative;
    height: 28px;

    .progress-track {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .progress-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #e0e0e0;
      transition: all 0.5s ease;
    }

    .progress-fill {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      transition: width 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.1);
    }

    /* 左侧圆角 + 右侧三角形 */
    .progress-bg.type1 {
      border-radius: 20px 0 0 20px;
      clip-path: polygon(0 0,
          calc(100% - 14px) 0,
          100% 50%,
          calc(100% - 14px) 100%,
          0 100%);
      //   clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 0%, 100% 100%, 0 100%);
    }

    .progress-fill.type1 {
      border-radius: 20px 0 0 20px;
      clip-path: polygon(0 0,
          calc(100% - 14px) 0,
          100% 50%,
          calc(100% - 14px) 100%,
          0 100%);
      //   clip-path: polygon(0 0, calc(100% - 14px) 0, 100% 0%, 100% 100%, 0 100%);
    }

    /* 左侧三角形 + 右侧圆角 */
    .progress-bg.type2 {
      border-radius: 0 20px 20px 0;
      //   clip-path: polygon(0 50%, 14px 0, 100% 0, 100% 100%, 14px 100%);
      clip-path: polygon(0 0,
          calc(100% - 14px) 0,
          100% 0%,
          100% 100%,
          0 100%,
          14px 50%);
    }

    .progress-fill.type2 {
      border-radius: 0 20px 20px 0;
      //   clip-path: polygon(0 50%, 14px 0, 100% 0, 100% 100%, 14px 100%);
      clip-path: polygon(0 0,
          calc(100% - 14px) 0,
          100% 50%,
          calc(100% - 14px) 100%,
          0 100%,
          14px 50%);
    }

    .progress-fill-full.type2 {
      clip-path: polygon(0 0,
          calc(100% - 14px) 0,
          100% 0%,
          100% 100%,
          0 100%,
          14px 50%);
    }
  }

  .percent_collage_box {
    font-size: 12px;
    color: #ffffff;
    width: 42px;
    height: 22px;
    position: relative;

    .percent_collage {
      position: absolute;
      top: 0;
      height: 0;
      width: 42px;
      height: 22px;
    }

    .percent_collage_percent {
      position: relative;
      text-align: center;
      z-index: 9;
    }
  }

  .percent_collage_box_none {
    opacity: 0;
  }

  .step_collage_box {
    .one_active {
      width: 40px;
      height: 34px;
    }

    .step_label {
      font-size: 14px;
      color: RGBA(183, 183, 183, 1);
      margin-top: -20px;
      position: relative;

      .step_active_lise {
        position: absolute;
        width: 100px;
        height: 6px;
        background: linear-gradient(180deg,
            #00d49b 0%,
            rgba(0, 213, 155, 0) 100%);
        opacity: 0.7;
        bottom: 0;
      }
    }

    .step_label_default {
      color: rgba(96, 96, 96, 1);
    }

    .step_label_active {
      color: rgba(16, 16, 16, 1);
    }

    .step_desc {
      color: RGBA(227, 227, 227, 1);
      font-size: 12px;
      margin-top: 5px;
    }

    .step_desc_default {
      color: rgba(225, 225, 225, 1);
    }

    .step_desc_active {
      color: rgba(144, 144, 144, 1);
    }

    .text_active {
      color: #13D6AA;
    }
  }
}
</style>